import { render, staticRenderFns } from "./PrimaryMenuColumn.vue?vue&type=template&id=43821f42&"
import script from "./PrimaryMenuColumn.vue?vue&type=script&lang=js&"
export * from "./PrimaryMenuColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43821f42')) {
      api.createRecord('43821f42', component.options)
    } else {
      api.reload('43821f42', component.options)
    }
    module.hot.accept("./PrimaryMenuColumn.vue?vue&type=template&id=43821f42&", function () {
      api.rerender('43821f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/menu/PrimaryMenuColumn.vue"
export default component.exports